import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonParse',
  standalone: true,
})
export class jsonParsePipe implements PipeTransform {
  transform(value: string): any {
    try {
      return JSON.parse(value);
    } catch (e) {
      console.error('Invalid JSON string:', value);
      return null;
    }
  }
}
